import { ActionTypes } from "../constants";

export default function icicCart(state = {}, action) {
  switch (action.type) {
    case ActionTypes.SET_ICICI_CART:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}